import request from "common/request"

//查询全部码表
export function codeTableAll(params){
  return request({
    url:'/bs/config/allDataList',
    method:'get',
    params
  })
}
//查询所有省市区列表
export function allCityList(query){
  return request({
    url:'/bs/config/listTreeDistrict',
    method:'get',
    params: query
  })
}
//查询所有省市区列表(生源)
export function listTreeStudentSourceDistrict(query){
  return request({
    url:'/bs/config/listTreeStudentSourceDistrict',
    method:'get',
    params: query
  })
}
//获取访问量
export function getWebCount(params){
  return request({
    url:'/bs/commons/webHits',
    method:'get',
    params
  })
}
// (问卷设置)用户问卷分页列表
export function questionUserList(params){
  return request({
      url:'/bs/commons/questionnaireSettingsListPage',
      method:'get',
      params,
      // headers:{
      //     'Cube-Auth':"eyJ0eXAiOiJKc29uV2ViVG9rZW4iLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJpc3N1c2VyIiwiYXVkIjoiYXVkaWVuY2UiLCJoYXNfU2VuZF9Nc2ciOiJudWxsIiwibG9naW5fdGVybWluYWwiOiJudWxsIiwiZnVsbF9uYW1lIjoiMTU1MjcxMzg2MTgiLCJ1c2VyX3R5cGUiOiIzIiwidXNlcl9pZCI6IjE2MjEzMjkxMDMxNjUyMTA2MjUiLCJ1c2VyX25hbWUiOiLliIfliIfliIciLCJkZXB0X25hbWUiOiLmioDmnK8iLCJ0b2tlbl90eXBlIjoiYWNjZXNzX3Rva2VuIiwiZXhwIjoxNjc5MTM2OTEzLCJuYmYiOjE2NzY1NDQ5MTN9.FiA6KumoGfymtTz5Crbjo2b6TReTtHRQqfdXGP_MzaM"
      // }
  })
}

export function questionnaireUserListPage(params){
  return request({
      url:'/bs/commons/questionnaireUserListPage',
      method:'get',
      params,
  })
}

//未读消息数量
export function unreadMessageCount(params){
  return request({
    url:'/bs/commons/getNoReadNotificationCount',
    method:'get',
    params
  })
}
//专业(不分页列表)
export function majorLists(params) {
  return request({
    url: '/bs/user/majorLists',
    method: 'get',
    params: params
  })
}
//院系(不分页列表)
export function deptLists(params) {
  return request({
    url: '/bs/user/deptLists',
    method: 'get',
    params: params
  })
}
//专业码表(不分页列表)
export function systemMajorLists(params) {
  return request({
    url: '/bs/user/systemMajorLists',
    method: 'get',
    params: params
  })
}
//学校码表(不分页列表)
export function systemSchoolLists(params) {
  return request({
    url: '/bs/user/systemSchoolLists',
    method: 'get',
    params: params
  })
}
